<template>
  <div class="patent-tech-distribution">
    <dv-border-box-12>
      <div class="patent-charts-container">
        <!-- 专利申请趋势 -->
        <div class="chart-item" style="margin-top: 20px;">
          <h3>专利申请趋势</h3>
          <div ref="trendChart" class="chart trend-chart"></div>
        </div>

        <!-- 机构竞争力 -->
        <div class="chart-item">
          <h3>机构竞争力</h3>
          <div ref="competitionChart" class="chart competition-chart"></div>
        </div>
      </div>
    </dv-border-box-12>
  </div>
</template>

<script>
import * as echarts from 'echarts';

// 引入雷达图扩展
import 'echarts/lib/chart/radar';

export default {
  name: "PatentTechDistribution",
  data() {
    return {
      myCharts: {},
      // 模拟数据
      patentData: {
        // 专利申请趋势数据
        trendData: {
          years: ['2018', '2019', '2020', '2021', '2022', '2023', '2024'],
          counts: [120, 200, 350, 480, 520, 650, 800],
          types: ['中药种植', '中药提取', '方剂创新', '质量控制']
        },
        // 技术主题聚类数据（气泡图）
        clusterData: [
          {name: '中药提取', value: 80, category: 0, patentCount: 120, year: 2022},
          {name: '成分分析', value: 65, category: 0, patentCount: 90, year: 2021},
          {name: '制剂技术', value: 70, category: 1, patentCount: 110, year: 2023},
          {name: '炮制工艺', value: 55, category: 1, patentCount: 85, year: 2020},
          {name: '质量检测', value: 90, category: 2, patentCount: 150, year: 2023},
          {name: '标准制定', value: 75, category: 2, patentCount: 105, year: 2022},
          {name: '种植技术', value: 60, category: 3, patentCount: 80, year: 2021},
          {name: '资源保护', value: 45, category: 3, patentCount: 65, year: 2020}
        ],
        // 机构竞争力数据（雷达图）
        competitionData: {
          institutions: ['中国中医科学院', '北京中医药大学', '上海中医药大学', '南京中医药大学', '广东中医药大学'],
          dimensions: ['专利数量', '引用次数', '技术创新性', '产业化程度', '国际影响力'],
          data: [
            {value: [90, 85, 80, 75, 70], name: '中国中医科学院'},
            {value: [85, 80, 85, 70, 75], name: '北京中医药大学'},
            {value: [80, 75, 75, 80, 65], name: '上海中医药大学'},
            {value: [75, 70, 80, 65, 60], name: '南京中医药大学'},
            {value: [70, 65, 75, 85, 60], name: '广东中医药大学'}
          ]
        }
      }
    }
  },
  methods: {
    // 生成最近7年的数据
    generateRecentYears() {
      const years = [];
      const currentYear = new Date().getFullYear();
      const lastYear = currentYear - 1;
      
      for (let i = 6; i >= 0; i--) {
        years.push(String(lastYear - i));
      }
      
      return years;
    },
    // 初始化专利申请趋势图
    initTrendChart() {
      const chartDom = this.$refs.trendChart;
      if (!chartDom) return;
      
      this.myCharts.trendChart = echarts.init(chartDom);
      const option = {
        tooltip: {
          trigger: 'axis',
          backgroundColor: 'rgba(0, 0, 0, 0.7)',
          textStyle: {
            color: '#fff'
          }
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          data: this.patentData.trendData.years,
          axisLine: {
            lineStyle: {
              color: '#999'
            }
          },
          axisLabel: {
            color: '#fff'
          }
        },
        yAxis: {
          type: 'value',
          name: '专利数量',
          nameTextStyle: {
            color: '#fff'
          },
          axisLine: {
            lineStyle: {
              color: '#999'
            }
          },
          axisLabel: {
            color: '#fff'
          },
          splitLine: {
            lineStyle: {
              color: 'rgba(255, 255, 255, 0.1)'
            }
          }
        },
        series: [
          {
            name: '专利总数',
            type: 'line',
            data: this.patentData.trendData.counts,
            smooth: true,
            lineStyle: {
              color: '#00C1FF',
              width: 3
            },
            symbol: 'circle',
            symbolSize: 8,
            itemStyle: {
              color: '#00C1FF',
              borderColor: '#fff',
              borderWidth: 2
            }
          }
        ]
      };
      
      this.myCharts.trendChart.setOption(option);
    },
    
    // 初始化技术主题聚类图
    initClusterChart() {
      const chartDom = this.$refs.clusterChart;
      if (!chartDom) return;
      
      this.myCharts.clusterChart = echarts.init(chartDom);
      const option = {
        tooltip: {
          trigger: 'item',
          formatter: params => {
            return `${params.name}<br/>专利数量: ${params.data.patentCount}<br/>年份: ${params.data.year}`;
          },
          backgroundColor: 'rgba(0, 0, 0, 0.7)',
          textStyle: {
            color: '#fff'
          }
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: {
          type: 'value',
          name: '技术成熟度',
          nameTextStyle: {
            color: '#fff'
          },
          axisLine: {
            lineStyle: {
              color: '#999'
            }
          },
          axisLabel: {
            color: '#fff'
          },
          splitLine: {
            lineStyle: {
              color: 'rgba(255, 255, 255, 0.1)'
            }
          }
        },
        yAxis: {
          type: 'value',
          name: '创新度',
          nameTextStyle: {
            color: '#fff'
          },
          axisLine: {
            lineStyle: {
              color: '#999'
            }
          },
          axisLabel: {
            color: '#fff'
          },
          splitLine: {
            lineStyle: {
              color: 'rgba(255, 255, 255, 0.1)'
            }
          }
        },
        series: [
          {
            type: 'scatter',
            symbolSize: function (val) {
              return val[2] / 10;
            },
            data: this.patentData.clusterData.map(item => [
              item.value,
              item.patentCount / 5,
              item.patentCount,
              item.name,
              item.year
            ]),
            itemStyle: {
              color: function(params) {
                // 根据技术领域设置不同颜色
                const colors = ['#FF6B6B', '#4ECDC4', '#FFE66D', '#1A535C'];
                return colors[params.data[0] % 4];
              },
              opacity: 0.8
            }
          }
        ]
      };
      
      this.myCharts.clusterChart.setOption(option);
    },
    
    // 初始化机构竞争力图
 initCompetitionChart() {
  const chartDom = this.$refs.competitionChart;
  if (!chartDom) return;
  
  this.myCharts.competitionChart = echarts.init(chartDom);
  const option = {
    tooltip: {
      trigger: 'axis',
      axisPointer: {
        type: 'shadow'
      },
      backgroundColor: 'rgba(0, 0, 0, 0.7)',
      textStyle: {
        color: '#fff'
      }
    },
    legend: {
      data: this.patentData.competitionData.institutions,
      textStyle: {
        color: '#fff'
      },
      orient: 'vertical',  // 设置图例垂直排列
      left: 'left',        // 设置图例在左侧
      top: 'center'        // 设置图例垂直居中
    },
    radar: {
      indicator: this.patentData.competitionData.dimensions.map(item => ({
        name: item,
        max: 100
      })),
      splitArea: {
        areaStyle: {
          color: ['rgba(255, 255, 255, 0.05)', 'rgba(255, 255, 255, 0.1)']
        }
      },
      axisLine: {
        lineStyle: {
          color: 'rgba(255, 255, 255, 0.2)'
        }
      },
      splitLine: {
        lineStyle: {
          color: 'rgba(255, 255, 255, 0.2)'
        }
      },
      name: {
        textStyle: {
          color: '#fff'
        }
      },
      center: ['65%', '50%'],  // 调整雷达图中心位置，为左侧图例留出空间
      radius: '70%'
    },
    series: [
      {
        type: 'radar',
        data: this.patentData.competitionData.data
      }
    ]
  };
  
  this.myCharts.competitionChart.setOption(option);
},
    
    // 初始化所有图表
    initCharts() {
      this.myCharts = {};
      this.initTrendChart();
      this.initClusterChart();
      this.initCompetitionChart();
      
      // 监听窗口大小变化，重新调整图表大小
      window.addEventListener('resize', this.handleResize);
    },
    
    // 处理窗口大小变化
    handleResize() {
      Object.values(this.myCharts).forEach(chart => {
        if (chart && chart.resize) {
          chart.resize();
        }
      });
    }
  },
  mounted() {
    // 动态生成最近7年的数据
    this.patentData.trendData.years = this.generateRecentYears();
    
    // 组件挂载后初始化图表
    this.initCharts();
  },
  beforeDestroy() {
    // 组件销毁前移除事件监听
    window.removeEventListener('resize', this.handleResize);
    
    // 销毁所有图表实例
    Object.values(this.myCharts).forEach(chart => {
      if (chart && chart.dispose) {
        chart.dispose();
      }
    });
  }
};
</script>

<style scoped>
.patent-tech-distribution {
  width: 100%;
  height: 100%;
}

.patent-charts-container {
  display: flex;
  flex-direction: column;
  height: calc(100% - 30px);
  gap: 10px;
  padding: 10px;
}

.chart-item {
  flex: 1;
  display: flex;
  flex-direction: column;
}

.chart-item h3 {
  margin: 0 0 5px 0;
  font-size: 14px;
  color: #fff;
  text-align: center;
}

.chart {
  flex: 1;
  width: 100%;
}
</style>